import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { getBadgeAchievements } from '../api/platform';
import { HistoryProp } from "../components/ContentHistory";

export interface IBadgeAchievementsData {
  content_histories: HistoryProp[];
  timeline_summary: object;
  email_content_type: object;
  has_achievement: number;
}
export interface GetBadgeAchievementsEventsObjectState {
  badgeAchievementsData: IBadgeAchievementsData;
  isLoading: boolean;
  error?: object;
}

const initialState: GetBadgeAchievementsEventsObjectState = {
  badgeAchievementsData: {
    content_histories: [],
    timeline_summary: {},
    email_content_type: {},
    has_achievement: 0,
  },
  isLoading: false,
  error: {}
};

export const getBadgeAchievementsEvents = createAsyncThunk(
  'getBadgeAchievementPlatform',
    async function (params:any) {
      const response = await getBadgeAchievements(params);
      return response ? response : {}
    }
);

export const getBadgeAchievementsSlice = createSlice({
  name: 'getBadgeAchievementsEvents',
  initialState,
  reducers: {
    setGetCertificateEventData: (state, action: PayloadAction<IBadgeAchievementsData>) => {
      state.isLoading = false;
      state.badgeAchievementsData = action.payload;
      state.error = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getBadgeAchievementsEvents.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getBadgeAchievementsEvents.fulfilled, (state: any, action: any) => {
      state.isLoading = false;
      state.badgeAchievementsData = action.payload;
      state.error = undefined;
    });

    builder.addCase(getBadgeAchievementsEvents.rejected, (state: any, action: any) => {
      state.isLoading = false;
      state.badgeAchievementsData = {};
      state.error = action.payload as string;
    });
  }
});

export const getBadgeAchievementsEventsDataSelector = (state: RootState) => state.badgeAchievementsEvents;
export default getBadgeAchievementsSlice.reducer;
